module.exports = __webpack_public_path__ + "static/media/next-gray.7012a7b8.svg";